import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { UtilitaService } from '../../services/utilita.service';
import { ConfermaComponent } from '../conferma/conferma.component';


import {
  IPayPalConfig,
  ICreateOrderRequest
} from 'ngx-paypal';




@Component({
  selector: 'app-modalita-di-pagamento',
  templateUrl: './modalita-di-pagamento.component.html',
  styleUrls: ['./modalita-di-pagamento.component.css']
})
export class ModalitaDiPagamentoComponent implements OnInit {
  public isEdit: number = 0;
  idRichiesta: any;
  objcalcolo: any;

  public payPalConfig?: IPayPalConfig;
  showSuccess: boolean = false;
  showCancel: boolean = false;
  showError: boolean = false;
    objrichiesta: any;

  constructor(private router: Router, private srvUtilita: UtilitaService, private snackBar: MatSnackBar,
    private dialog: MatDialog) {



  }

  ngOnInit(): void {

    if (!this.srvUtilita.isUtenteLoggato()) {
      // this.router.navigate(['/auth/login']);
      this.router.navigate(['/accesso']);
    }

   



    this.idRichiesta = localStorage.getItem('idRichiesta');
    this.getRichiesta();
    this.getCalcolo();

    
  }

  getRichiesta() {
    this.srvUtilita.getObj('Utenti/GetRichiesta?idRichiesta=' + this.idRichiesta).subscribe((res: any) => {
      this.objrichiesta = res
      console.log(this.objrichiesta, 'objrichiesta')
    })
  }

  btnAggiungiAlCarrelllo() {
    //  this.isEdit = 1;
  }

  btnConfermaIlPagamento() {
    //this.isEdit = 1;

    this.router.navigate(['/dashboard/richiesta-adesione/riepilogo-richiesta-adesione/modalita-di-pagamento/richiesta-di-adesione/'])

  }

  getCalcolo() {
    this.srvUtilita.getObj('Utenti/GetQuotaAnnuale?iIdRichiesta=' + this.idRichiesta).subscribe((res: any) => {
      this.objcalcolo = res;
     console.log(res, 'res quota annuale')

      this.initConfig();
    })
  }


  showMessage(message: string, action: string) {
    this.snackBar.open(message, action, { duration: 3000 })
  }


  private initConfig(): void {
     
     
    this.payPalConfig = {
      currency: 'EUR',
     
    clientId: 'AZNqeEjG-M_wKa3EKal7uxS9x5S-8T04KS7AsmtciwouxB6Tn3ak3J297Fg0aKybDS1Uk-gmvbFPLT5E',
      createOrderOnClient: (data) => <ICreateOrderRequest>{
        intent: 'CAPTURE',
        purchase_units: [{
          amount: {
            currency_code: 'EUR',
            value: this.objcalcolo ,
            breakdown: {
              item_total: {
                currency_code: 'EUR',
                value: this.objcalcolo
              }
            }
          },
          items: [{
            name: 'Richiesta di adesione' + this.idRichiesta,
            quantity: '1',
            unit_amount: {
              currency_code: 'EUR',
              value: this.objcalcolo,
            },
          }]
        }]
      },
      advanced: {
        commit: 'true'
      },
      style: {
        layout: 'vertical',
        shape: 'pill',
        label: 'paypal'
      },
      onApprove: (data, actions) => {
        console.log('onApprove - transaction was approved, but not authorized', data, actions);
        actions.order.get().then((details: any) => {
          console.log('onApprove - you can get full order details inside onApprove: ', details);
          
        });

      },
      onClientAuthorization: (data) => {
        console.log('onClientAuthorization - you should probably inform your server about completed transaction at this point', data);
        this.showSuccess = true;

        this.srvUtilita.getObj('Utenti/PostGeneraRicevutaPaypal?idRichiesta=' + this.idRichiesta).subscribe((res: any) => {
            console.log('pagamento OK da paypal idRichiesta: ', this.idRichiesta);
          this.router.navigate(["/dashboard/richiesta-adesione/riepilogo-richiesta-adesione/modalita-di-pagamento/pagamento-ok/"]);

        })
        
       
      },
      onCancel: (data, actions) => {
        console.log('OnCancel', data, actions);
        this.showCancel = true;
        this.router.navigate(["/dashboard/richiesta-adesione/riepilogo-richiesta-adesione/modalita-di-pagamento/pagamento-annullato/"]);

      },
      onError: err => {
        console.log('OnError', err);
        this.showError = true;
        this.router.navigate(["/dashboard/richiesta-adesione/riepilogo-richiesta-adesione/modalita-di-pagamento/pagamento-annullato/"]);
      },
      onClick: (data, actions) => {
        console.log('onClick', data, actions);
      }
    };
  }
}
